export const faqData = [
    {
        title: "Which scholarship to consider in-case of multiple eligibilities?",
        desc: "In-case of multiple eligibilities, only ONE SCHOLARSHIP will be consider, whichever is higher",
    },
    {
        title: "What is the Admission Process?",
        desc: "You can view our Admission Process under the Home tab.",
    },
]